export default __webpack_public_path__ + "static/media/sampleReport5.2c3de202.png";